import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import { Icon, Typography } from '@packages/ui/shared';

const PREVIEW_FAILED_MESSAGE = 'Failed to load video.\nTry downloading it instead.';
const PREVIEW_UNSUPPORTED_MESSAGE = 'Preview not available.\nDownload to view the file.';

export interface VideoViewerProps {
    fileName: string;
    videoUrl: string;
}

const useStyles = createUseStyles({
    container: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
    video: {
        maxWidth: '70%',
        maxHeight: '70%',
        objectFit: 'contain',
    },
});

export function VideoViewer({ fileName, videoUrl }: VideoViewerProps) {
    const classes = useStyles();
    const [hasError, setHasError] = useState(false);

    return (
        <div className={classes.container} data-testid="video-viewer">
            {hasError ? (
                <>
                    <Icon name="videocam" color="white" size={90} />
                    <Typography variant="lead" color="white" style={{ marginBottom: 8 }}>
                        {fileName}
                    </Typography>
                    <Typography color="white" variant="lead">
                        {PREVIEW_FAILED_MESSAGE}
                    </Typography>
                </>
            ) : (
                <video key={videoUrl} autoPlay controls className={classes.video} onError={() => setHasError(true)}>
                    <source src={videoUrl} type="video/mp4" />
                    {PREVIEW_UNSUPPORTED_MESSAGE}
                </video>
            )}
        </div>
    );
}
